const pulseConstants = {
    lists: {
        watchlist: {
            typeId: 1,
            handle: 'watchlist',
        },
        interests: {
            typeId: 2,
            handle: 'interests',
        },
        playlist: {
            typeId: 3,
            handle: 'playlist',
            basketMinItems: 1,
        },
        pulsePlaylist: {
            typeId: 4,
            handle: 'pulsePlaylist',
        },
        followlist: {
            typeId: 5,
            handle: 'followlist',
        },
        pulseComparison: {
            typeId: 6,
            handle: 'pulseComparison',
        },
        comparison: {
            typeId: 7,
            handle: 'comparison',
            basketMinItems: 2,
            basketMaxItems: 6,
        },
    },
    benchmarking: {
        viewBy: {
            scores: 'scores',
            features: 'features',
        },
        views: {
            radar: 'radar',
            table: 'table',
            column: 'column',
        },
    },
    search: {
        searchAll: 'searchAll',
        screenshotText: 'screenshotsText',
        brand: 'brand',
        indexes: {
            screenshots: 'screenshots',
        },
    },
};

export default pulseConstants;
